import { useMutation } from "@tanstack/react-query";

import { startValidationRun } from "services";

type StartValidationRunParams = string | { versionTag: string; forceRerun?: boolean };

export const useStartValidationRun = () =>
  useMutation({
    mutationFn: (params: StartValidationRunParams) =>
      typeof params === "string" ? startValidationRun(params) : startValidationRun(params.versionTag, params.forceRerun),
  });
